import { CustomPartCanvas } from "../components/CustomPartCanvas";
import { CustomOptions } from "../components/CustomOptions";
import { StampingPreview } from "../components/StampingPreview";
import { Texture } from "../components/Texture";
import Product from "../components/Product";
import { Collapse, Popover } from "bootstrap";
import { gsap } from "gsap";

// 更 robust 的 safeReplacer，防 circular reference 及所有特殊物件
function safeReplacer() {
  const seen = new WeakSet();
  return function (key, value) {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) return undefined;
      seen.add(value);
    }
    try {
      if (
        typeof value === "function" ||
        (typeof Element !== "undefined" && value instanceof Element) ||
        (typeof HTMLCanvasElement !== "undefined" && value instanceof HTMLCanvasElement) ||
        (typeof CanvasRenderingContext2D !== "undefined" && value instanceof CanvasRenderingContext2D) ||
        value === window ||
        value === document
      ) {
        return undefined;
      }
    } catch (e) {
      return undefined;
    }
    return value;
  };
}

export default class CustomProductPage {
  constructor(dom) {
    this.dom = dom;
    this.texturesArray = [];
    this.isLoading = false;
    window.addEventListener("resize", () => this.resize());
  }
  async init() {
    this.productResult = this.initProduct();
    this.texturesResult = this.initTextures();

    this.customPartCanvas = await this.initCustomPartCanvas();
    this.stampingPreview = this.initStampingPreview();
    this.stampingPreview.init();
    this.customPartCanvas.attachStampingPreview(this.stampingPreview);

    await this.initOptionSelector();
    this.createUIDOM(
      this.productResult.productParts,
      this.texturesResult.partOptions
    );
    this.initOptionsUI();

    this.rebuildSetup();
  }

  async initCustomPartCanvas() {
    this.customOptions = new CustomOptions(
      this.productResult.productUID,
      this.productResult.productName
    );

    const canvasContainer = document.querySelector("#canvas-container");
    let canvas = new CustomPartCanvas(canvasContainer, this.productResult);
    await canvas.init();

    let actionbuttons = document.querySelectorAll(
      "button[data-target=generatePreview]"
    );
    for (let actionbtn of actionbuttons) {
      actionbtn.addEventListener("click", (e) => {
        if (
          this.isLoading ||
          actionbtn.getAttribute("data-target") != "generatePreview"
        ) {
          return;
        }

       
        
        this.isLoading = true;
        (async () => {
                    // alert('[DEBUG] start async block');
          // try {
            // const imgData = this.getCanvasImage();
            const imgData2 = await this.getCanvasImage2();
            // alert('[DEBUG] imgData2 type: ' + typeof imgData2 + ', head: ' + (imgData2 ? imgData2.substring(0, 20) : 'null'));
            let metaData = [];
            // if (document.querySelector('.wc-pao-addon-customisation-data textarea')) {
            //   metaData = this.getFullConfig()
            // }
            this.compareCurrentJSON();
                        // alert('[DEBUG] after compareCurrentJSON');
            this.updateWooAddOnsConfig();
                        // alert('[DEBUG] after updateWooAddOnsConfig');
            metaData = this.getFullConfig();
                        // alert('[DEBUG] after getFullConfig');
                        // try {
                        //   alert('[DEBUG] metaData: ' + JSON.stringify(metaData, safeReplacer()));
                        // } catch (e) {
                        //   alert('[DEBUG] metaData stringify error: ' + e);
                        // }
            console.log('[DEBUG] metaData:', metaData);
            if (!metaData || !Array.isArray(metaData.productPartsOptions)) {
              console.error('[ERROR] metaData.productPartsOptions is not array', metaData);
              alert('Config error, please try again.');
              this.isLoading = false;
              return;
            }
            delete metaData.productName;
            let metaData_slug = metaData.productUID;
            metaData.productPartsOptions.forEach((option, i) => {
              if (!option || typeof option.uid !== 'string') {
                console.error('[ERROR] option or option.uid invalid', option);
                throw new Error('Invalid part option');
              }
              option.uid = option.uid.replace(`${metaData_slug}-`, ``);
            });
            let jsonBody;
            try {
              jsonBody = JSON.stringify({
                // previmg: imgData,
                previmg2: imgData2,
                metaData: metaData,
              });
            } catch (err) {
              console.error('[ERROR] JSON.stringify failed', err, metaData);
              alert('Config too complex or invalid.');
              this.isLoading = false;
              return;
            }
            const rawResponse = await fetch(
              `${root}${lang == "tc" ? "" : lang}?www_api=1&cmd=generate_preview`,
              {
                method: "POST",
                body: jsonBody,
                headers: {
                  "Content-Type": "application/json;charset=utf-8",
                },
              }
            );
            if(lang=="tc"){
              setTimeout(function(){
                alert('商品已為您放入購物車。');
              }, 0);
            }else{
              setTimeout(function(){
                alert("We've added this to your cart for you");
              }, 0);
            }
            let content;
            try {
              content = await rawResponse.json();
            } catch (err) {
              console.error('[ERROR] response.json() failed', err, rawResponse);
              alert('Server response error.');
              this.isLoading = false;
              return;
            }
            this.isLoading = false;
            console.log('[DEBUG] content:', content);
            if (content.code == 200) {
              if (document.querySelector(".wc-pao-addon-preview-image input")) {
                document.querySelector(
                  ".wc-pao-addon-preview-image input"
                ).value = content.res;
              }
              if (document.querySelector(".single_add_to_cart_button")) {
                document.querySelector(".single_add_to_cart_button").click();
              }
            }
          // } catch (err) {
          //   console.error('[FATAL ERROR]', err);
          //   alert(err);
          //   this.isLoading = false;
          // }
        })();

        // if(document.querySelector(".single_add_to_cart_button")){
        //   document.querySelector(".single_add_to_cart_button").click();
        // }
      });
    }

    return canvas;
  }

  async initOptionSelector() {
    for (let part of this.productResult.productParts) {
      this.customOptions.createPartOption(part.partUID, part.partType);
    }

    for (let category of this.texturesResult.partOptions) {
      if (this.texturesArray[category.textureType] == undefined) {
        this.texturesArray[category.textureType] = [];
      }
      for (let txt of category.textureList) {
        let newTexture = new Texture(
          category.textureType,
          category.textureCategory,
          category.textureCategoryID,
          txt
        );
        await newTexture.load();
        this.texturesArray[category.textureType].push(newTexture);
      }
    }

    let actionbuttons = document.querySelectorAll(
      "button[data-target=generatePreview"
    );
    for (let actionbtn of actionbuttons) {
      actionbtn.disabled = false;
    }

    let pageLoader = document.querySelector(".page-loader");
    if (pageLoader) {
      gsap.to(pageLoader, {
        opacity: 0,
        duration: 0.35,
        delay: 0.5,
        onComplete: () => {
          pageLoader.remove();
        },
      });
    }
  }

  initStampingPreview() {
    let preview = new StampingPreview(
      this.customPartCanvas,
      this.productResult.stamping
    );
    return preview;
  }

  createUIDOM(productParts, optionsList) {
    const optionsWrapper = document.createElement("div");
    optionsWrapper.id = "customisation-palettes";
    optionsWrapper.classList = "accordion accordion-flush";

    const mainDiv = this.dom.querySelector(
      "#customisation-controls > .inner-wraper"
    );
    mainDiv.innerHTML = "";
    mainDiv.append(optionsWrapper);

    let textureCategoryHTMLs = [];
    for (let category of this.texturesResult.partOptions) {
      const categoryWrapper = document.createElement("div");
      categoryWrapper.classList = "cat-wrapper";
      categoryWrapper.setAttribute(
        "data-option-cat",
        category.textureCategoryID
      );
      const categoryName = document.createElement("h4");
      categoryName.innerText = category.textureCategory;
      categoryWrapper.append(categoryName);
      textureCategoryHTMLs[category.textureCategoryID] = categoryWrapper;

      for (let texture of category.textureList) {
        const option = document.createElement("div");
        option.classList = "option";
        option.setAttribute("data-bs-toggle", "popover");
        option.setAttribute("data-bs-trigger", "hover focus");
        option.setAttribute("data-bs-placement", "bottom");
        option.setAttribute("data-bs-content", texture.textureName);

        if (texture.unavailable === "true") {
          option.classList.add("unavailable");
        }

        option.setAttribute("data-option-id", texture.textureUID);
        const image = new Image();
        image.crossOrigin = "Anonymous";
        image.src = texture.textureIcon;
        option.append(image);
        categoryWrapper.append(option);
      }
    }
    for (let part of productParts) {
      if (part.partType == "unchangeable-item") continue;

      const partItem = document.createElement("div");
      partItem.classList = "partItem accordion-item";

      const accordionHeader = document.createElement("div");
      accordionHeader.classList = "accordion-header part-option";
      accordionHeader.id = part.partUID;
      partItem.append(accordionHeader);

      const partButton = document.createElement("button");
      partButton.classList = "accordion-button collapsed";
      partButton.setAttribute("type", "button");
      partButton.setAttribute("data-bs-toggle", "collapse");
      partButton.setAttribute(
        "data-bs-target",
        "#" + accordionHeader.id + "-options"
      );
      partButton.setAttribute("aria-expanded", "false");
      partButton.setAttribute("aria-controls", accordionHeader.id + "-options");
      accordionHeader.append(partButton);

      const selectionIcon = document.createElement("div");
      selectionIcon.classList = "selection-icon";
      partButton.append(selectionIcon);

      const partLabel = document.createElement("div");
      partLabel.classList = "part-label";
      partLabel.innerText = part.partName;
      partButton.append(partLabel);

      const partSelectionDesc = document.createElement("div");
      partSelectionDesc.classList = "selection-desc";
      const partSelectionType = document.createElement("div");
      partSelectionType.classList = "selection-desc-type";
      partSelectionDesc.append(partSelectionType);
      const partSelectionValue = document.createElement("div");
      partSelectionValue.classList = "selection-desc-value";
      partSelectionDesc.append(partSelectionValue);
      partButton.append(partSelectionDesc);

      const partCost = document.createElement("div");
      partCost.classList = "selection-cost";
      partCost.innerText = "0.00";
      partButton.append(partCost);

      const partOptions = document.createElement("div");
      partOptions.id = accordionHeader.id + "-options";
      partOptions.classList = "accordion-collapse collapse part-selector";
      partOptions.setAttribute("aria-labelledby", accordionHeader.id);
      partOptions.setAttribute("data-bs-parent", "#" + optionsWrapper.id);
      partOptions.setAttribute("data-part-id", accordionHeader.id);

      partOptions.setAttribute("data-opt-class", part.optionClass);

      const partOptionsBody = document.createElement("div");
      partOptionsBody.classList = "accordion-body";

      for (let cat of part.partTypeCats) {
        if (textureCategoryHTMLs[cat]) {
          partOptionsBody.innerHTML += textureCategoryHTMLs[cat].outerHTML;
        }
      }

      partOptions.append(partOptionsBody);
      partItem.append(partOptions);

      optionsWrapper.append(partItem);
    }
    const popoverTriggerList = this.dom.querySelectorAll(
      '[data-bs-toggle="popover"]'
    );
    const popoverList = [...popoverTriggerList].map(
      (popoverTriggerEl) => new Popover(popoverTriggerEl)
    );

    //control show / hide
    let btnCustomNextStep = this.dom.querySelector("#customNextStep");
    let customProductDOM = this.dom;
    if (btnCustomNextStep) {
      btnCustomNextStep.addEventListener("click", function () {
        let tmpStamping = customProductDOM.querySelector(
          "#customisation-stamping"
        );
        let tmpOptControls = customProductDOM.querySelector(
          "#customisation-controls"
        );
        console.log(tmpOptControls.classList);
        if (tmpStamping.classList.contains("d-none")) {
          console.log("show stamping");
          tmpStamping.classList.remove("d-none");
          tmpOptControls.classList.add("d-none");
          btnCustomNextStep.innerHTML =
            tmpOptControls.querySelector("h3").textContent;
          tmpStamping.scrollIntoView({ block: "end" });
        } else if (tmpOptControls.classList.contains("d-none")) {
          console.log("show Opt Controls");
          tmpStamping.classList.add("d-none");
          tmpOptControls.classList.remove("d-none");
          btnCustomNextStep.innerHTML =
            tmpStamping.querySelector("h3").textContent;
          tmpOptControls.scrollIntoView();
        }
        btnCustomNextStep.innerHTML += '<span class="icon-btn-arrow"></span>';
      });
    }
  }

  initOptionsUI() {
    this.dom.querySelectorAll(".part-selector .option").forEach((option) => {
      option.addEventListener("click", () => {
        let partID = option
          .closest(".part-selector")
          .getAttribute("data-part-id");
        let partCategory = option
          .closest(".cat-wrapper")
          .getAttribute("data-option-cat");
        let optionID = option.getAttribute("data-option-id");
        let texture = this.fetchTextureByID(optionID);

        if (texture.unavailable !== "true") {
          this.customPartCanvas.updatePart(partID, texture);
          this.customOptions.updatePartOption(partID, partCategory, optionID);

          const partOption = this.dom.querySelector(`.part-option#${partID}`);
          this.updateOptionsUI(partOption, texture);

          if (partID == this.productResult.stamping.partUID) {
            if (texture.noColorlessStamping === "true") {
              this.stampingPreview.disableColorlessStamping();
            } else {
              this.stampingPreview.enableColorlessStamping();
            }
          }

          this.dom
            .querySelectorAll("#customisation-controls .collapse")
            .forEach((collapse) => {
              let c = new Collapse(collapse, {
                toggle: false,
              });
              c.hide();
            });
        }
      });
    });

    if (this.dom.querySelector("#partSelector select[name='partchanger']")) {
      let targetInput = this.dom
        .querySelector("#partSelector select[name='partchanger']")
        .getAttribute("target-input");
      document.querySelector(
        "." + targetInput + " input[type=text].wc-pao-addon-field"
      ).value = this.dom.querySelector(
        "#partSelector select[name='partchanger'] option"
      ).value;

      this.dom
        .querySelector("#partSelector select[name='partchanger']")
        .addEventListener("change", (e) => {
          let tmpChoice = this.dom.querySelector(
            "#partSelector select[name='partchanger'] option[value='" +
              e.target.value +
              "']"
          );
          let partfront = tmpChoice.dataset.partfront;
          let targetpart = e.target.getAttribute("target-part");
          let targetInput = e.target.getAttribute("target-input");
          let tmpTexture = "";
          let tmpTypeUID = "";
          console.log(targetpart);
          // this.customPartCanvas.updatePart(targetpart, '',partfront);
          let currentConfig = this.getFullConfig();
          if (Array.isArray(currentConfig.productPartsOptions)) {
            currentConfig.productPartsOptions.forEach((tmpObj) => {
              if (tmpObj.uid == targetpart) {
                tmpTexture = this.fetchTextureByID(tmpObj.typeUID);
                tmpTypeUID = tmpObj.typeUID;
                // console.log(tmpTexture);
              }
            });
          }
          for (let opt of this.customPartCanvas.customPartOpts) {
            if (opt.choice_value == e.target.value) {
              this.customPartCanvas.updatePartMask(targetpart, opt);
              this.customPartCanvas.updatePart(targetpart, tmpTexture);
              document.querySelector(
                "." + targetInput + " input[type=text].wc-pao-addon-field"
              ).value = opt.choice_value;
              // console.log( document.querySelector("."+targetInput+" input[type=text].wc-pao-addon-field"));
              // console.log( document.querySelector("."+targetInput+" input[type=text].wc-pao-addon-field").value);
            }
          }

          /*
        this.customPartCanvas.updatePartMask(targetpart,partfront);
        this.customPartCanvas.updatePart(targetpart, tmpTexture);
        
        let partOption = this.dom.querySelector(
          `.part-selector[data-part-id="${targetpart}"]`
        );
        if (partOption && tmpTypeUID) {
          let partOptionChoice = partOption.querySelector(
            `.option[data-option-id="${tmpTypeUID}"]`
          );
          PartOption = partOptionChoice;
          setTimeout(()=>{
            let clickevent = new Event("click");
            partOptionChoice.dispatchEvent(clickevent);
          },100);
        }
        */
        });
    }

    this.dom.querySelectorAll(".part-option").forEach((option) => {
      let partID = option.getAttribute("id");
      option.addEventListener("pointerenter", () => {
        this.customPartCanvas.highlightPart(partID);
      });
      option.addEventListener("pointerleave", () => {
        this.customPartCanvas.draw();
        this.compareCurrentJSON();
        this.updateWooAddOnsConfig();
      });
    });

    this.dom.querySelectorAll(".part-selector .option").forEach((option) => {
      option.addEventListener("pointerenter", () => {
        let partID = option
          .closest(".part-selector")
          .getAttribute("data-part-id");
        let optionID = option.getAttribute("data-option-id");
        let texture = this.fetchTextureByID(optionID);
        this.customPartCanvas.previewPart(partID, texture);
        /* Update for woo addon */
        let optionClass = option
          .closest(".part-selector")
          .getAttribute("data-opt-class");
        this.changeWooAddOnsOpt(optionClass, texture.catID);
      });
      option.addEventListener("pointerleave", () => {
        this.customPartCanvas.draw();
        this.updateWooAddOnsConfig();
      });
    });
  }

  updateOptionsUI(header, texture) {
    let icon = header.querySelector(".selection-icon");
    let desc = header.querySelector(".selection-desc");
    let cost = header.querySelector(".selection-cost");

    icon.style.backgroundImage = `url(${texture.iconSrc})`;

    desc.innerHTML = "";
    let category = document.createElement("div");
    category.innerText = texture.category;
    let name = document.createElement("div");
    name.innerText = `${texture.name} (${texture.code})`;
    desc.append(category);
    desc.append(name);

    cost.innerText = texture.extraCost;
  }

  rebuildSetup() {
    let configJSONStr = `{"productUID":"prod-1","productName":"Cross ID Case","productPartsOptions":[{"uid":"prod-1-back1","type":"leather","typeCategoryID":"texture-leather-classic-brush","typeUID":"08-juice"},{"uid":"prod-1-cover","type":"leather","typeCategoryID":"texture-leather-classic-brush","typeUID":"06-midnight-blue"},{"uid":"prod-1-back2","type":"leather","typeCategoryID":"texture-leather-classic-brush","typeUID":"03-darkbrown"},{"uid":"prod-1-back3","type":"leather","typeCategoryID":"texture-leather-vivid-tint","typeUID":"07-mint-green"},{"uid":"prod-1-stitch","type":"stitch","typeCategoryID":"texture-stitch","typeUID":"17-ivory"}],"stamping":{"option":"colorless","font":"italian","content":"Mother"},"isValid":true}`;
    let presetName = "";
    const input = document.querySelector("input[name=customisation_preset]");
    if (input) {
      configJSONStr = input.value;
      presetName = input.getAttribute("data-preset");
    }

    if (configJSONStr.trim()) {
      let configJSON = JSON.parse(configJSONStr);

      let productDIV = document.querySelector(".single-product");
      if (productDIV) {
        // console.log(configJSON);
        let productObj = new Product(productDIV);
        productObj.productUID = configJSON.productUID;
        productObj.changeWooAddOnsConfig(configJSON);

        if (configJSON.productUID != this.customOptions.productUID) {
          console.log("ProductID mis-match. Config rebuild aborted.");
          return;
        }

        let incomingPartOptions = configJSON.productPartsOptions;
        for (let option of incomingPartOptions) {
          let partOption = this.dom.querySelector(
            `.part-selector[data-part-id="${option.uid}"]`
          );
          if (option.typeUID && option.uid) {
            let partOptionChoice = partOption.querySelector(
              `.option[data-option-id="${option.typeUID}"]`
            );
            partOptionChoice?.click();
          }
        }

        this.stampingPreview.updateConfig(configJSON.stamping);
        this.updateWooAddOnsConfig();
        /*
        let tmpPath = '?www_api=1&cmd=get_product';
          fetch(tmpPath)
          .then((response) => response.json())
          .then((data) => {

        });
        */
      }
    }
  }
  compareCurrentJSON() {
    let configJSONStr = "";
    let presetName = "";
    const input = document.querySelector("input[name=customisation_preset]");
    if (input) {
      configJSONStr = input.value;
      presetName = input.getAttribute("data-preset");
    }

    if (configJSONStr.trim()) {
      let configJSON = JSON.parse(configJSONStr);
      let currentConfigJSON = this.getFullConfig();

      let orgParts = configJSON.productPartsOptions;
      let currentParts = currentConfigJSON.productPartsOptions;

      orgParts.forEach(function (value, index) {
        if (value.typeUID != currentParts[index].typeUID) {
          presetName = "Full Customisation";
        }
      });
      return presetName;
    }
  }
  fetchTextureByID(id) {
    for (let [textureType, textureList] of Object.entries(this.texturesArray)) {
      let needle = textureList.find((t) => t.uid == id);
      if (needle != undefined) {
        return needle;
      }
    }
  }
  changeWooAddOnsOpt(optClass, textureCatOpt) {
    let tmpCatOpt = textureCatOpt.split("texture-");
    if (optClass && tmpCatOpt[1]) {
      let selectFeild = document.querySelector(
        "." + optClass + " .wc-pao-addon-field"
      );
      if (selectFeild) {
        let tmpoptions = Array.from(selectFeild.options);
        let optionToSelect = tmpoptions.find(
          (item) => item.dataset.label === tmpCatOpt[1]
        );
        if (optionToSelect) {
          optionToSelect.selected = true;
        }
      }
    }
    this.updateWooAddOnsConfig();
  }
  updateWooAddOnsConfig() {
    this.stampingPreview.updateStampingOptions();
    let customOptionWrapper = document
      .querySelector(".page-wrapper")
      .getAttribute("data-target_class");
    // console.log(customOptionWrapper);
    let customsummaryfeild = document.querySelector(
      "." + customOptionWrapper + " textarea.wc-pao-addon-field"
    );
    // console.log(customsummaryfeild);
    if (customsummaryfeild) {
      customsummaryfeild.value = JSON.stringify(this.getFullConfig());
      let totalCost = 0;
      let orgPriceObj = document.querySelector("#custom-price-calculate");
      let additionalCosts = document.querySelectorAll(".selection-cost");
      if (orgPriceObj.getAttribute("data-orgprice")) {
        totalCost = parseFloat(orgPriceObj.getAttribute("data-orgprice"));
        for (let additionCost of additionalCosts) {
          totalCost += parseFloat(additionCost.textContent);
        }
      }

      let presetClass = document
        .querySelector(".page-wrapper")
        .getAttribute("data-preset");
      let presetFeild = document.querySelector(
        "." + presetClass + " input.wc-pao-addon-field"
      );
      presetFeild.value = this.compareCurrentJSON();

      if (totalCost) {
        document.querySelector("#custom-price-calculate .result").textContent =
          "$" + totalCost.toFixed(2);
      }
    }
  }

  initProduct() {
    let result = {};
    const product = this.dom.querySelector("productSetup");
    result.productUID = product.getAttribute("data-productUID");
    result.productName = product.getAttribute("data-productName");
    result.addShadow = product.getAttribute("data-addShadow");

    result.stamping = [];
    result.stamping.partUID = product.getAttribute("data-stampPartUID");
    result.stamping.posX = product.getAttribute("data-stampPosX").split(",");
    result.stamping.posY = product.getAttribute("data-stampPosY").split(",");
    result.stamping.alignment = product.getAttribute("data-stampAlignment");
    result.stamping.size = product.getAttribute("data-stampSize");
    result.stamping.limit = product.getAttribute("data-stampLimit");

    result.productParts = [];

    const productParts = product.querySelectorAll("productPart");
    for (let p of productParts) {
      let part = {};
      part.partUID = p.getAttribute("data-partUID");
      part.partOrder = p.getAttribute("data-partOrder");
      part.partType = p.getAttribute("data-partType");

      part.optionClass = p.getAttribute("data-optionClass");

      let attr = p.getAttribute("data-partTypeCats");
      let attrArr = attr.split(",");
      for (let a of attrArr) {
        a = a.trim();
      }
      part.partTypeCats = attrArr;

      part.partName = p.getAttribute("data-partName");
      part.partFront = p.getAttribute("data-partFront");
      part.partBack = p.getAttribute("data-partBack");
      result.productParts.push(part);
    }

    result.productParts.sort((a, b) => a.partOrder - b.partOrder);

    result.productPartOpts = [];
    if (this.dom.querySelector("#partSelector select[name='partchanger']")) {
      const productPartOpts = this.dom.querySelectorAll(
        "#partSelector select[name='partchanger'] option"
      );
      for (let p of productPartOpts) {
        let part = {};
        part.partUID = this.dom
          .querySelector("#partSelector select[name='partchanger']")
          .getAttribute("target-part");
        part.partFront = p.getAttribute("data-partfront");
        part.choice_value = p.getAttribute("value");
        part.customShadow = p.getAttribute("data-shadow");
        result.productPartOpts.push(part);
      }
    }

    return result;
  }

  initTextures() {
    let result = {};
    result.partOptions = [];
    const textures = this.dom.querySelector("textureSetup");
    let textureCats = textures.querySelectorAll("textureCategory");
    for (let textureCat of textureCats) {
      let cat = {};
      cat.textureCategory = textureCat.getAttribute("data-textureCategory");
      cat.textureCategoryID = textureCat.getAttribute("data-textureCategoryID");
      cat.textureType = textureCat.getAttribute("data-textureType");
      cat.textureExtraCost = textureCat.getAttribute("data-textureExtraCost");
      cat.textureNoColorlessStamping = textureCat.getAttribute(
        "data-textureNoColorlessStamping"
      );

      let textures = textureCat.querySelectorAll("texture");
      cat.textureList = [];
      for (let t of textures) {
        let texture = {};
        texture.textureUID = t.getAttribute("data-textureUID");
        texture.textureName = t.getAttribute("data-textureName");
        texture.textureCode = t.getAttribute("data-textureCode");
        texture.textureIcon = t.getAttribute("data-textureIcon");
        texture.textureFront = t.getAttribute("data-textureFront");
        texture.textureBack = t.getAttribute("data-textureBack");
        texture.unavailable = t.getAttribute("data-unavailable");
        texture.extraCost = cat.textureExtraCost;
        texture.noColorlessStamping = cat.textureNoColorlessStamping;
        cat.textureList.push(texture);
      }

      result.partOptions.push(cat);
    }
    return result;
  }

  getFullConfig() {
    let fullConfig = this.customOptions.getConfig();
    fullConfig.stamping = this.stampingPreview.getConfig();

    fullConfig.isValid = true;
    for (let part of fullConfig.productPartsOptions) {
      if (part.type != "unchangeable-item") {
        if (part.typeUID == null) {
          fullConfig.isValid = false;
        }
      }
    }

    // console.log(JSON.stringify(fullConfig));
    return fullConfig;
  }

  getCanvasImage() {
    return this.customPartCanvas.canvas.toDataURL("image/png");
  }
  async getCanvasImage2(retryCount = 0) {
    try {
      const previewCanvas = document.createElement("canvas");
      const previewCtx = previewCanvas.getContext("2d");
      const scale = 0.5;
      if (!this.customPartCanvas || !this.customPartCanvas.canvas) {
        console.log('[DEBUG] customPartCanvas or canvas is null!');
        throw new Error('customPartCanvas or canvas is null!');
      }
      const srcWidth = this.customPartCanvas.canvas.width;
      const srcHeight = this.customPartCanvas.canvas.height;
      previewCanvas.width = srcWidth * scale;
      previewCanvas.height = srcHeight * scale;
      if (srcWidth === 0 || srcHeight === 0) {
        if (retryCount < 10) {
          // Retry after 100ms, up to 10 times
          setTimeout(() => this.getCanvasImage2(retryCount + 1), 100);
          return;
        }
        throw new Error('Canvas not ready: size is 0x0. 請先選擇產品選項或稍後再試。');
      }
      try {
        previewCtx.drawImage(
          this.customPartCanvas.canvas,
          0, 0,
          previewCanvas.width,
          previewCanvas.height
        );
      } catch (e) {
        console.log('[DEBUG] drawImage error:', e);
        throw e;
      }
      return previewCanvas.toDataURL("image/jpeg", 0.5);
    } catch (err) {
      console.log('[DEBUG] getCanvasImage2 error:', err);
      throw err;
    }
  }
  resize() {}
}
